module.exports = __webpack_public_path__ + "img/no_login.4a7a46dc.png";